import axiosInstance from '../api/AxiosInstance';

export type LocalidadOption = {
  id: string;
  label: string;
};

export function normalizeLocalidad(item: any): LocalidadOption | null {
  const idRaw = item?.idLocalidad ?? item?.id ?? item?.localidadId;
  const labelRaw = item?.descripcion ?? item?.nombre ?? item?.localidad;
  if (idRaw === undefined || idRaw === null || !labelRaw) return null;
  return {
    id: String(idRaw),
    label: String(labelRaw),
  };
}

export async function fetchLocalidadesCatalogo(): Promise<LocalidadOption[]> {
  const res = await axiosInstance.get('/cLocalidadRoutes');
  const rows = Array.isArray(res.data) ? res.data : [];
  const normalized = rows
    .map(normalizeLocalidad)
    .filter(Boolean) as LocalidadOption[];

  const seen = new Set<string>();
  return normalized.filter((loc) => {
    const key = `${loc.id}|${loc.label}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
